import {
  ChatUserRoleDto,
} from '../../apis/nhe-ai-chat-service/nhe-ai-chat-service.dtos';

export const osmosisVideoUrl = 'https://www.osmosis.org';

export const TEMP_BOT_CHAT_ID = 8888888888;
// Identity for the display-only optimistic user entry (AiChatState.tempUserEntry). It lives
// outside chatEntries, so this id is only ever used as a React key -- it plays no part in
// filtering or sorting.
export const TEMP_USER_ENTRY_ID = 7777777777;
export const ADMIN_MODAL_ID = 'ADMIN_MODAL_ID';

export enum IframeEvent {
  SHERPATH_AI_PROMPT_SUBMITTED = 'SHERPATH_AI_PROMPT_SUBMITTED',
  SHERPATH_AI_LINK_CLICK = 'SHERPATH_AI_LINK_CLICK',
  SHERPATH_AI_PAGE_CONTEXT_UPDATE = 'SHERPATH_AI_PAGE_CONTEXT_UPDATE',
  SHERPATH_AI_IFRAME_READY = 'SHERPATH_AI_IFRAME_READY',
  SHERPATH_AI_SUBMIT_USER_MESSAGE = 'SHERPATH_AI_SUBMIT_USER_MESSAGE',
  SHERPATH_AI_NAVIGATE_TO_CITATION = 'SHERPATH_AI_NAVIGATE_TO_CITATION',
  OSMOSIS_AI_LEARN_PAGE_CLICK = 'OSMOSIS_AI_LEARN_PAGE_CLICK',
  // Posted to window.parent so an embedding iframe (e.g. Sherpath AI) gets a chance to
  // reboot/reload the app itself before we navigate the inner frame to the timeout page.
  SHERPATH_AI_SESSION_EXPIRED = 'SHERPATH_AI_SESSION_EXPIRED',
  // Sent by the embedding host to ask this app for its current session/token status.
  SHERPATH_AI_SESSION_STATUS_REQUEST = 'SHERPATH_AI_SESSION_STATUS_REQUEST',
  // Reply to SHERPATH_AI_SESSION_STATUS_REQUEST, posted back to event.source rather than
  // window.parent so it reaches whichever frame actually asked.
  SHERPATH_AI_SESSION_STATUS_RESPONSE = 'SHERPATH_AI_SESSION_STATUS_RESPONSE',
}

export type SessionStatusResponseMessage = {
  type: IframeEvent.SHERPATH_AI_SESSION_STATUS_RESPONSE;
  isValid: boolean;
  timeToExpiration: number;
  // Echoed back from the request, if present, so a host with more than one status
  // request in flight can match each reply to the request that triggered it.
  requestId?: string;
};

// Sent by the embedded assessment player itself, not by NAA, so the value is that
// external app's contract and must not be renamed to match NAA's own naming conventions.
export enum AssessmentPlayerIframeEvent {
  ASSESSMENT_PLAYER_COMPLETE = 'ASSESSMENT_PLAYER_COMPLETE'
}

export const ALLOWED_MESSAGE_ORIGINS = [
  '.osmosis.org',
  '.elsevier.com',
  '.vitalsource.com'
];

export enum ChatConnectionProtocol {
  HTTP_STREAM = 'HTTP_STREAM',
  WEB_SOCKETS = 'WEB_SOCKETS',
  HTTP_POST = 'HTTP_POST',
}

export const MAX_PROMPT_LENGTH = 2500;
export const MAX_PROMPT_LENGTH_DISPLAY = '2,500';

export const pageSize = 50;

export const ChatUserRoleDisplayMap: Record<ChatUserRoleDto, string> = {
  [ChatUserRoleDto.STUDENT]: 'Student',
  [ChatUserRoleDto.INSTRUCTOR]: 'Instructor',
  [ChatUserRoleDto.INSTRUCTOR_AS_STUDENT]: 'Student',
}

export enum ChatModeType {
  DEFAULT_STUDY_MODE = 'DEFAULT_STUDY_MODE',
  TUTOR_MODE = 'TUTOR_MODE',
}

export const isValidChatModeType = (value: unknown): value is ChatModeType =>
  typeof value === 'string' && Object.values<string>(ChatModeType).includes(value);

export const ChatModeTypeDisplayMap: Record<ChatModeType, string> = {
  [ChatModeType.DEFAULT_STUDY_MODE]: 'Study mode',
  [ChatModeType.TUTOR_MODE]: 'Tutor mode',
}

export const CHAT_MODE_TYPE_STORAGE_KEY = 'nhe-ai-chat-mode-type';

